<!--
@负责人: zhijie.huang
@创建时间: 2018-11-02
@版本: v2.0.0
@描述: 图表
@使用方法:
<template>
  <chart ref="someChart" chart-id="someChart" :chart-data="chartData"></chart>
</template>
<script>
import chart from '@/components/chart/chart-base'

drawChart (data) {
  this.chartData = {
    rows: data,
    columns: ['eventTime', 'value'],
    formatMap: {
      eventTime: 'TIME'
    }
  }
}

</script>
@参数说明:
// 图表id
// chartId
// 图表数据
// chartData = {
  // 数据
  rows: [],
  // 维度+指标1+指标2...
  columns: ['eventTime', 'value'],
  // 指标的文本
  labelMap: {
    eventTime: '时间',
    value: '数值'
  },
  // 数据格式化 默认NUMBER 'PERCENT','NUMBER','SIZE','TIME'(时间没有年份),'TIMELONG'(时间完整格式)
     NUMBER和SIZE可通过 -格式 显示数据格式 如: NUMBER-ms SIZE-BYTE
  formatMap: {
    eventTime: 'TIME',
    value: NUMBER
  },
  // 线条颜色 颜色列表长度对应数据数组长度
  colors: ['#0B8DE5', '#9B8AE5']
  // series样式
  seriesStyle: {
    lineStyle: {
      normal: {
        width: 1.6
      }
    }
  },
}
// 图表option
// chartStyle
// 是否黑色主题
// darkTheme
-->
<style>
.chart {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
  border: 1px solid #f0f0f0;
}
.chart--dark {
  color: #333;
  background: #9e9e9e;
}
.chart-wrap,
.chart-box--nodata {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
.chart-box--nodata {
  display: table;
  font-size: 16px;
  font-weight: bold;
}
.chart-box__nodata-tip {
  display: table-cell;
  vertical-align: middle;
}
</style>
<template>
  <div class="chart"
    :class="{'chart--dark': darkTheme}">
    <div class="chart-wrap"
      id="chart-wrap">
      <div class="chart-box"
        :style="domStyle"
        v-show="!noData"
        :id="chartId"></div>
      <div class="chart-box--nodata text-center"
        v-show="noData">
        <p class="chart-box__nodata-tip"
          v-text="$t('chart.noData')"></p>
      </div>
    </div>
  </div>
</template>
<script>
import { extend } from '@/utils/tool'
import ChartHelper from '@/components/chart/chart'
import EventCenter from '@/utils/eventCenter'
let echarts = require('echarts')
const eventCenter = EventCenter()

const DEFAULT_STYLE = {
  width: '400px',
  height: '220px'
}
export default {
  components: {},
  data() {
    return {
      baseChartOption: ChartHelper.BASE_OPTION(),
      basePieChartOption: ChartHelper.PIE_BASE_OPTION(),
      domStyle: DEFAULT_STYLE,
      chartInstance: null,
      noData: false,
      baseOptions: null
    }
  },
  props: {
    type: {
      type: String,
      default: 'LINE'
    },
    chartId: {
      type: String,
      require: true
    },
    chartData: {
      type: Object
    },
    chartStyle: {
      type: Object,
      default: null
    },
    chartIndex: {
      type: Number
    },
    darkTheme: {
      type: Boolean
    }
  },
  watch: {
    chartId: function(value) {
      if (value) {
        this.chartInit(value)
        setTimeout(() => {
          this.resize()
        }, 100)
      }
    },
    chartData: function(value) {
      if (value) {
        this.chartDataHandle(value)
      }
    },
    domStyle: {
      deep: true,
      handler: function(value) {
        if (value) {
          this.resize()
        }
      }
    },
    chartStyle: {
      deep: true,
      handler: function(val) {
        this.updateStyle()
      }
    },
    noData: function(val, oldVal) {
      if (oldVal && val === false) {
        this.resize()
      }
    }
  },
  methods: {
    getBaseOptions() {
      return this.type === 'PIE'
        ? this.basePieChartOption
        : this.baseChartOption
    },
    checkWrapChange() {
      const wrapDom = document.getElementById(this.chartId)
      if (!wrapDom) return false
      if (
        wrapDom.clientHeight !== this.chartInstance.getHeight() ||
        wrapDom.clientWidth !== this.chartInstance.getWidth()
      ) {
        return true
      }
      return false
    },
    destory() {
      if (this.chartInstance) {
        this.chartInstance.dispose()
        this.chartInstance = null
      }
    },
    restore() {
      this.destory()
      setTimeout(() => {
        this.chartInit(this.chartId)
      })
    },
    chartInit(id) {
      if (this.chartInstance === null) {
        this.chartInstance = echarts.init(document.getElementById(id))
        this.updateStyle()
      }
    },
    resize() {
      if (this.chartInstance && !this.chartInstance.isDisposed()) {
        this.chartInstance.resize()
      }
    },
    updateStyle() {
      let style = this.getBaseOptions()
      if (this.chartStyle !== null) {
        // style = extend(true, style, this.chartStyle)
        for (let i in this.chartStyle) {
          style[i] = this.chartStyle[i]
        }
      }
      this.baseOptions = style
    },
    chartDataHandle(data) {
      if (this.baseOptions === null) {
        this.updateStyle()
      }
      this.$nextTick(() => {
        const options = extend(
          true,
          {},
          ChartHelper.chartDataHandle(
            data,
            this.chartIndex,
            this.type,
            this.baseOptions
          )
        )
        if (Object.keys(options).length > 0) {
          this.noData = false
          this.drawChart(options)

          setTimeout(() => {
            if (this.checkWrapChange()) this.resize()
          }, 150)
        } else {
          this.noData = true
        }
      })
    },
    drawChart(options) {
      if (this.chartInstance === null) {
        this.chartInit(this.chartId)
      }
      try {
        // this.chartInstance.clear()
        // 不和之前的数据合并
        this.chartInstance.setOption(options, true)
      } catch (err) {
        console.error('Error on this.chartInstance.setOption', err)
      }
      if (this.chartId && this.chartId.indexOf('chartGroups') > -1) {
        this.chartInstance.group = this.chartId.split('-')[1]
        echarts.connect(this.chartId.split('-')[1])
      }
    }
  },
  mounted() {
    if (this.chartId) {
      this.chartInit(this.chartId)
      if (this.chartData && Object.keys(this.chartData).length > 0) {
        this.chartDataHandle(this.chartData)
      }
      setTimeout(() => {
        this.domStyle = {
          width: '100%',
          height: '100%'
        }
        eventCenter.addResizeEvent(`chart-base-${this.chartId}`, () => {
          if (this.checkWrapChange()) this.resize()
        })
      }, 100)
    }
  },
  destroyed() {
    this.destory()
  }
}
</script>